export default __webpack_public_path__ + "static/media/fsw_6.8aee925a.png";